/*
 *
 * SiteOwnerTestResults constants
 *
 */

export const SLICE_NAME = 'siteownertestresults';
